import React from 'react';
import { css } from '@linaria/atomic';
import { UpdateIcon } from '../../../icon/icons/update';
import { ActionPressedChip } from '../atoms/action-pressed-chip';

const redoActionUpdateIconStyle1 = css`
  transform: scaleX(-1);
`;

type RedoActionProps = Omit<React.ComponentProps<typeof ActionPressedChip>, 'children'>;

export const RedoAction = ({ compact = true, showBoxShadow = true, ...rest }: RedoActionProps) => {
  return (
    <ActionPressedChip {...rest} compact={compact} showBoxShadow={showBoxShadow}>
      <UpdateIcon className={redoActionUpdateIconStyle1} size={16} />
    </ActionPressedChip>
  );
};
